<div id="crop-health-note-get-direction">
  <p class="description">{{ 'doktar_app.services.crop_monitoring.map_get_direction_message' | translate }}</p>
  <div class="row">
    <div class="col-4">
      <div class="box" [class.selected]="selected == 'apple'" (click)="selected = 'apple'">
        <dk-apple-icon />
        <p>{{ 'doktar_app.common.apple_maps' | translate }}</p>
      </div>
    </div>
    <div class="col-4">
      <div class="box" [class.selected]="selected == 'google'" (click)="selected = 'google'">
        <dk-google-icon />
        <p>{{ 'doktar_app.common.google_maps' | translate }}</p>
      </div>
    </div>
    <div class="col-4">
      <div class="box" [class.selected]="selected == 'yandex'" (click)="selected = 'yandex'">
        <dk-yandex-icon />
        <p>{{ 'doktar_app.common.yandex_maps' | translate }}</p>
      </div>
    </div>

    <div class="col-12 mt-3">
      <p-button
        [label]="'doktar_app.common.select' | translate"
        severity="primary"
        [disabled]="!selected"
        (onClick)="getDirection()" />
    </div>
  </div>
</div>
